/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntityTypeEnum } from './entityTypeEnum';


export interface SyncVersionSpec { 
    entity_type: EntityTypeEnum;
    /**
     * Deployment or Org Ids
     */
    ids: Array<string>;
}
export namespace SyncVersionSpec {
}


